import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';
import { Icon, Table, TableColumnOpcoes } from '@components';
import { getTarefas, reset as resetTarefas } from '@ducks/conectoresTarefas';

export default function TableTarefas() {
  const dispatch = useDispatch();
  const history = useHistory();
  const { idConfiguracao, idFonteDado } = useParams();

  const tarefas = useSelector(({ conectoresTarefas }) => conectoresTarefas.get('tarefas').toArray());
  const loadingTarefas = useSelector(({ conectoresTarefas }) => conectoresTarefas.get('loadingTarefas'));

  const handleSearch = () => {
    dispatch(getTarefas(idConfiguracao, idFonteDado));
  };

  const handleReset = () => {
    dispatch(resetTarefas());
  };

  useEffect(() => {
    handleReset();
  }, []);

  useEffect(() => {
    handleSearch();
  }, []);

  const columns = [
    {
      title: 'Tarefa',
      dataIndex: 'ds',
      key: 'ds',
    },
    {
      title: 'Opções',
      dataIndex: 'id',
      key: 'options',
      align: 'right',
      width: '7%',
      render: (text, item) => (
        <TableColumnOpcoes>
          <Icon.Edit
            action={() => history.push(`/conectores/configuracao/${item.idConfiguracao}/fonte/dado/${item.idFonteDado}/tarefa/${item.id}`)}
          />
          <Icon.Detail />
        </TableColumnOpcoes>
      ),
    },
  ];

  return <Table rowKey="id" columns={columns} dataSource={tarefas} loading={loadingTarefas} hidePagination />;
}
